import axios from '../../utils/axios';

export const getBlogsAsync = async () => {
    const blogs = await axios.get("/blogs");
    return blogs.data;
}